"use strict";

// We overload ints to be both integers and references. We use an encoding
// scheme to differentiate. (Even numbers are refs, odds are ints)
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decode = exports.encode = exports.isReference = void 0;
function isReference(value) {
  return Number.isInteger(value) && value % 2 === 0;
}
exports.isReference = isReference;
function encode(value, {
  reference
} = {
  reference: false
}) {
  if (Number.isInteger(value) === false) {
    return value;
  }
  if (reference) {
    return value * 2;
  }
  return value * 2 + 1;
}
exports.encode = encode;
function decode(value) {
  if (Number.isInteger(value) === false) {
    return value;
  }
  const integer = value;
  if (integer % 2 === 0) {
    return integer / 2;
  }
  return (integer - 1) / 2;
}
exports.decode = decode;